import type { ModalProps } from '@nuxt/ui'

const calendarModal: NonNullable<ModalProps['ui']> = {
  content: 'w-full sm:max-w-xl',
}

const mapModal: NonNullable<ModalProps['ui']> = {
  header: 'justify-center',
  body: 'p-0 sm:p-0',
}

const filtersModal: NonNullable<ModalProps['ui']> = {
  content: 'max-w-6xl',
}
export { calendarModal, mapModal, filtersModal }
